module.exports = __webpack_public_path__ + "static/Janowo_Park_III_ujecie_06-d44d5905ed1c97c27db133a71719af30.jpg";